import { InitialData } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { conditionalIntegerRangeValidator, plainText, richText } from '../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../modules/formatters';
import { HubModuleDefaultView, HubModuleLayout } from '../../../../../../../../api/event-hubs.dao';

export const ENABLED = 'enabled';
export const LABEL = 'label';
export const DISPLAY_LABEL = 'displayLabel';
export const DESCRIPTION = 'description';
export const DISPLAY_SPEAKERS = 'displaySpeakers';
export const LAYOUT = 'layout';
export const DEFAULT_VIEW = 'defaultView';
export const DISPLAY_UPCOMING_EVENTS = 'displayUpcomingEvents';
export const UPCOMING_EVENTS_DAYS = 'upcomingEventDays';
export const DISPLAY_PAST_EVENTS = 'displayPastEvents';
export const PAST_EVENTS_DAYS = 'pastEventDays';
export const POSITION_ORDER = 'positionOrder';

export const MIN_EVENTS_DAYS = 1;
export const MAX_EVENTS_DAYS = 999;
export const DEFAULT_UPCOMING_EVENTS_DAYS = 365;
export const DEFAULT_PAST_EVENTS_DAYS = 30;

const isFieldEnabled = (key: string) => (values: InitialData): boolean => !!(values as Record<string, unknown>)[key];

export const EVENTS_BASE_FORM_CONFIG = {
    [ENABLED]: {
        defaultValue: true,
    },
    [LABEL]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [DISPLAY_LABEL]: {
        defaultValue: true,
    },
    [DESCRIPTION]: {
        defaultValue: '',
        validators: [richText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
    [DISPLAY_SPEAKERS]: {
        defaultValue: true,
    },
    [LAYOUT]: {
        defaultValue: HubModuleLayout.CAROUSEL,
    },
    [DEFAULT_VIEW]: {
        defaultValue: HubModuleDefaultView.COLLAPSED,
    },
    [DISPLAY_UPCOMING_EVENTS]: {
        defaultValue: true,
    },
    [UPCOMING_EVENTS_DAYS]: {
        defaultValue: DEFAULT_UPCOMING_EVENTS_DAYS,
        validators: [conditionalIntegerRangeValidator(MIN_EVENTS_DAYS, MAX_EVENTS_DAYS, isFieldEnabled(DISPLAY_UPCOMING_EVENTS))],
    },
    [DISPLAY_PAST_EVENTS]: {
        defaultValue: false,
    },
    [PAST_EVENTS_DAYS]: {
        defaultValue: DEFAULT_PAST_EVENTS_DAYS,
        validators: [conditionalIntegerRangeValidator(MIN_EVENTS_DAYS, MAX_EVENTS_DAYS, isFieldEnabled(DISPLAY_PAST_EVENTS))],
    },
    [POSITION_ORDER]: {
        defaultValue: 0,
    },
};
